'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Fisherman HTTP Util Abstraction
// Nick Loeper - Last updated Wednesday February 7th, 2018

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTTP = function () {
  function HTTP(config) {
    _classCallCheck(this, HTTP);

    this.instance = _axios2.default.create(config);
  }

  _createClass(HTTP, [{
    key: 'get',
    value: function get(url, options) {
      return this.instance.get(url, options);
    }
  }, {
    key: 'post',
    value: function post(url, data, options) {
      return this.instance.post(url, [data, options]);
    }
  }, {
    key: 'delete',
    value: function _delete(url, options) {
      return this.instance.delete(url, options);
    }
  }, {
    key: 'put',
    value: function put(url, data, options) {
      return this.instance.put(url, data, options);
    }
  }, {
    key: 'all',
    value: function all(requests) {
      return this.instance.all(requests);
    }
  }]);

  return HTTP;
}();

exports.default = HTTP;